<!--  -->
<template>
  <div class="personal-main">
    <el-row>
      <el-col :span="10">
        <el-upload
          class="avatar-uploader wid-hei100"
          :action="actionS"
          ref="upload"
          :data="Uids"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :on-change="handleChange"
          :headers="importHeaders"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar width100p" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <el-form :model="addForm" label-width="80px" ref="addForms">
          <el-form-item label="单位名称" prop="comp02">
            <el-input
              v-model="addForm.Company.comp02"
              disabled
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="单位类别" prop="comp05">
            <el-input
              v-model="addForm.Company.comp05"
              disabled
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="comp04">
            <el-input
              v-model="addForm.Company.comp04"
              disabled
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系地址">
            <!-- <el-cascader size="large" :options="options" v-model="dz" @change="handleChangess"></el-cascader> -->
            <el-input
              v-model="addForm.Company.comp06"
              disabled
              placeholder
            ></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="comp07">
            <el-input
              v-model="addForm.Company.comp07"
              disabled
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="网址" prop="comp11">
            <el-input
              v-model="addForm.Company.comp08"
              disabled
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="微信绑定">
            <el-radio-group class="mar-r50" v-model="isBind" disabled>
              <el-radio-button label="是"></el-radio-button>
              <el-radio-button label="否"></el-radio-button>
            </el-radio-group>
            <el-button
              v-if="isBind == '否'"
              size="small"
              type="primary"
              @click="bindWechat"
              >绑定微信</el-button
            >
            <el-button v-else size="small" type="danger" @click="UnbindWeChat"
              >解除绑定</el-button
            >
          </el-form-item>
          <el-form-item>
            <div id="login_container"></div>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="11" :offset="1">
        <el-form
          :rules="rules"
          :model="addForm.User"
          label-width="80px"
          ref="addForm"
        >
          <el-form-item label="姓名" prop="user04">
            <el-input v-model="addForm.User.user04"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="14">
              <el-form-item label="性别" label-width="60px" prop="user05">
                <el-radio-group v-model="addForm.User.user05">
                  <el-radio-button label="男"></el-radio-button>
                  <el-radio-button label="女"></el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              账户
              <el-input
                v-model="addForm.User.user02"
                class="width75"
                placeholder="请输入账户"
              ></el-input>
            </el-col>
          </el-row>
          <el-form-item label="出生年月" prop="user06">
            <el-date-picker
              v-model="addForm.User.user06"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="地址:" prop="user10">
            <div class="container">
              <div class="dome-main">
                <div
                  class="city-picker-selector"
                  id="city-picker-selector1"
                ></div>
              </div>
            </div>
            <el-input v-model="detialAdree" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="职称" prop="user07">
            <el-select v-model="addForm.User.user07" placeholder="请选择职称">
              <el-option
                v-for="(item, index) in jobs"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学历" prop="user08">
            <el-select v-model="addForm.User.user08" placeholder="请选择">
              <el-option
                v-for="(item, index) in education"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-row :gutter="10">
            <el-form-item label="手机号" prop="user11">
              <el-col :span="17">
                <el-input
                  type="number"
                  v-model.number="addForm.User.user11"
                ></el-input>
              </el-col>
              <el-col :span="4">
                <el-button type="info" plain @click="replace"
                  >更换手机号</el-button
                >
              </el-col>
            </el-form-item>
          </el-row>
          <el-form-item label="邮箱" prop="user12">
            <el-input
              v-model="addForm.User.user12"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <p class="dialog-footer">
      <el-button @click="unSubmit">取 消</el-button>
      <el-button type="primary" @click="submitUpload('addForm')"
        >确 定</el-button
      >
    </p>

    <!-- 更换手机号弹窗 -->
    <el-dialog
      title="更换手机号"
      :append-to-body="true"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <el-card class="box-card">
        <el-tabs v-model="activeName">
          <el-tab-pane label="输入当前帐号密码" name="1" disabled>
            <el-input
              class="pane-input"
              v-model="CurrentPwd"
              placeholder="请输入当前帐号密码"
            ></el-input>
            <!-- 按钮 -->
            <el-row class="pane-row">
              <el-button class="btn-size" type="primary" @click="Goback()"
                >返回</el-button
              >
              <el-button
                class="row-submi btn-size"
                type="primary"
                @click="Nextstep()"
                >下一步</el-button
              >
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="新手机号验证" name="2" disabled>
            <el-form
              ref="numberValidateForm"
              label-width="80px"
              class="demo-ruleForm"
            >
              <el-form-item>
                <el-input
                  class="pane-NewIph"
                  v-model="IphoneNumber"
                  placeholder="请输入新手机号"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  class="input-with-select"
                  v-model="vericode"
                  placeholder="请输入验证码"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="Getvericode()"
                    >获取验证码</el-button
                  >
                </el-input>
              </el-form-item>
              <!-- 按钮 -->
              <el-form-item class="el-form-item__content">
                <el-button class="btn-size" type="primary" @click="step"
                  >上一步</el-button
                >
                <el-button class="btn-size" type="primary" @click="determine()"
                  >确定</el-button
                >
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import { regionData, CodeToText } from "element-china-area-data";
import {
  GetPersonalCenter,
  EditPersonalCenter,
  CheckEditUser,
  UnbindWeChat,
  CheckUserName,
  BindWeChat,
  Verifypassword,
  shortproving,
  replaceIph,
} from "@/setAxios";
import { format } from "path";
export default {
  name: "personal",
  components: {},
  data() {
    var checkAge = (rule, value, callback) => {
      let _this = this;
      var reg1 = /^1[3-9]\d{9}$/;
      if (!reg1.test(_this.addForm.User.user11)) {
        return callback(new Error("请输入正确的手机格式"));
      } else {
        callback();
      }
    };
    var checkAge1 = (rule, value, callback) => {
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      let _this = this;
      if (!reg.test(_this.addForm.User.user12)) {
        return callback(new Error("请输入正确的邮箱格式"));
      } else {
        callback();
      }
    };
    return {
      jobs: [
        { name: "初级" },
        { name: "中级" },
        { name: "副高级" },
        { name: "高级" },
      ],
      detialAdree: "",
      rules: {
        user11: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkAge, trigger: "blur" },
        ],
        user12: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: checkAge1, trigger: "blur" },
        ],
        user06: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        user04: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        user07: [{ required: true, message: "请输入职称", trigger: "blur" }],
        user08: [{ required: true, message: "请输入学历", trigger: "blur" }],
      },
      importHeaders: { token: localStorage.getItem("token") },
      actionS: this.$store.state.baseUrl + "/api/UploadUserImg",
      Uids: {
        uid: localStorage.getItem("id"),
      },
      dz: [],
      addForm: {
        Company: {},
        User: {},
      },
      isBind: "否",
      imageUrl: "",
      options: regionData,
      selectedOptions: [],
      education: [
        { name: "小学" },
        { name: "初中" },
        { name: "中专/高中" },
        { name: "专科" },
        { name: "本科" },
        { name: "硕士研究生" },
        { name: "博士研究生" },
      ],
      activeName: "1",
      dialogVisible: false,
      CurrentPwd: "",
      IphoneNumber: "",
      vericode: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    unSubmit() {
      this.$emit("aaa");
    },
    // 接触绑定
    UnbindWeChat() {
      this.$confirm("是否解除绑定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var params = { uid: localStorage.id };
        UnbindWeChat(params).then((res) => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: "解除成功!",
            });
          } else {
            this.$message({
              type: "danger",
              message: "解除失败!",
            });
          }
          this.listData();
        });
      });
    },
    // 微信绑定
    bindWechat() {
      new WxLogin({
        id: "login_container",
        appid: "wxa983fcfd0157af0e",
        scope: "snsapi_login",
        state: "",
        redirect_uri: location.origin + "/#/",
      });
    },
    first() {
      var that = this;
      // 模拟城市-无联动/无搜索
      var selector1 = $("#city-picker-selector1").cityPicker({
        dataJson: cityData,
        renderMode: true,
        search: true,
        storage: true,
        autoSelected: true,
        shorthand: false,
        code: "cityCode",
        level: 2,
        onChoiceEnd: function () {
          that.addForm.User.user10 = selector1.getCityNameVal();
        },
      });
      if (that.addForm.User.user10 != null) {
        selector1.setCityVal(that.addForm.User.user10.split("/")[0]);
        that.detialAdree = that.addForm.User.user10.split("/")[1];
        that.addForm.User.user10 = that.addForm.User.user10.split("/")[0];
      }
    },
    show() {
      this.listData();
    },
    handleAvatarSuccess(response, file, fileList) {
      if (response.Code == 1) {
        this.$message({
          type: "success",
          message: "修改头像成功",
        });
        this.addForm.User.user13 = response.Data;
        this.$emit("getuserinfo");
        this.imageUrl = URL.createObjectURL(file.raw);
      }
    },
    beforeAvatarUpload(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("file", this.Uids);
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension =
        suffix === "png" ||
        suffix === "jpg" ||
        suffix === "bmp" ||
        suffix === "tif" ||
        suffix === "webp" ||
        suffix === "jpeg";
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!extension) {
        this.$message({
          message: "上传文件只能是图片类型!",
          type: "warning",
        });
        this.loading2 = false;
      }
      if (!isLt10M) {
        this.$message({
          message: "上传文件大小不能超过10MB!",
          type: "warning",
        });
      }
      return extension && isLt10M;
    },
    // 确定按钮  执行提交
    submitUpload(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            phone: this.addForm.User.user11,
            email: this.addForm.User.user12,
            uid: localStorage.getItem("id"),
          };
          // 判断手机号/邮箱存不存在
          CheckEditUser({ params }).then((res) => {
            if (res.Code == 1) {
              this.$message.error("手机号或邮箱已存在！");
            } else {
              // 执行修改个人资料
              CheckUserName({
                name: this.addForm.User.user02,
                uid: this.addForm.User.user01,
              }).then((res) => {
                if (res.Code == 0) {
                  this.addForm.User.user10 =
                    this.addForm.User.user10 + "/" + this.detialAdree;
                  params = JSON.stringify(this.addForm.User);
                  EditPersonalCenter({ model: params }).then((res) => {
                    if (res.Code == 1) {
                      this.$message({
                        type: "success",
                        message: "成功修改个人信息",
                      });
                      // 关闭表单
                      this.$emit("getuserinfo");
                      this.$emit("aaa");
                    } else {
                      this.$message.error("修改失败");
                    }
                  });
                } else {
                  this.$message.error("账户已存在!");
                }
              });
            }
          });
        } else {
          this.$message.error("表单填写有误！");
          return false;
        }
      });
    },
    // 监听修改的图片
    handleChange(file, fileList) {
      //("cc", file.name);
      this.imageUrl = URL.createObjectURL(file.raw);
      this.$store.state.userImgs = this.imageUrl.substr(
        this.imageUrl.lastIndexOf("/")
      );
    },

    // 地址修改
    handleChangess(i) {
      //(i);
    },
    // 获取用户信息
    listData() {
      let params = {
        uid: localStorage.getItem("id"),
        pid: localStorage.getItem("pid"),
      };
      GetPersonalCenter({ params }).then((res) => {
        this.addForm.Company = res.Data.Company;
        this.addForm.User = res.Data.User;
        this.addForm.User.user20 == null
          ? (this.isBind = "否")
          : (this.isBind = "是");
        this.imageUrl = this.$store.state.baseUrl + res.Data.User.user13;
        setTimeout(() => {
          this.first();
        }, 100);
      });
    },

    //更换手机号
    replace() {
      this.dialogVisible = true;
    },
    //关闭更换手机号弹窗
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    //更换手机号下一步按钮
    Nextstep() {
      if (this.CurrentPwd == "") {
        this.$message.warning("请输入当前帐号密码！！");
        return;
      } else {
        let currPwd = this.CurrentPwd;
        Verifypassword({ pwd: currPwd }).then((res) => {
          if (res.Code == 1) {
            //Tab标签页切换
            this.activeName = Number(this.activeName) + 1 + "";
          } else {
            this.$message.error("密码错误！请重新输入");
          }
        });
      }
    },
    //上一步按钮
    step() {
      this.activeName = Number(this.activeName) - 1 + "";
      this.IphoneNumber = "";
      this.vericode = "";
    },
    //返回按钮
    Goback() {
      this.dialogVisible = false;
      this.CurrentPwd = "";
    },
    //获取验证码按钮
    Getvericode() {
      if (this.IphoneNumber == "") {
        this.$message.warning("请输入新手机号码");
      } else {
        let NewIph = this.IphoneNumber;
        shortproving({ phonenumber: NewIph }).then((res) => {
          if (res.Code == 1) {
            this.$message.success(res.Message);
          } else {
            this.$message.error(res.Message);
          }
        });
      }
    },
    //确定按钮
    determine() {
      if (this.vericode == "") {
        this.$message.warning("请输入手机验证码！");
      } else {
        let params = {
          newPhoneNum: this.IphoneNumber,
          smsCode: this.vericode,
        };
        replaceIph(params).then((res) => {
          if (res.Code == 1) {
            this.dialogVisible = false;
            this.$confirm(res.Message, "注册成功", {
              confirmButtonText: "返回登录",
              iconClass: "el-icon-success",
            }).then(() => {
              this.CurrentPwd = "";
              this.IphoneNumber = "";
              this.vericode = "";
            });
          } else {
            this.$message.error(res.Message);
          }
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.listData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang="less" scoped>
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
/deep/ .el-upload {
  width: 100%;
  height: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader {
  text-align: center;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  margin-bottom: 20px;
  margin-left: 80px;
}
.avatar {
  margin: 0 auto;
  width: 100%;
  height: 100%;
}
.container {
  margin: 0px;
  width: 500px;
}
.dome-main {
  padding: 0px;
}
.dialog-footer {
  text-align: center;
  margin-top: -20px;
  padding-bottom: 10px;
  //新增
  margin: 0;
}
// 新增
.wid-hei100 {
  width: 100px;
  height: 100px;
}
.width100p {
  width: 100px;
}
.mar-r50 {
  margin-right: 50px;
}
.width75 {
  width: 75%;
}
.dialog-footer {
}

//新增
.pane-input {
  position: relative;
  margin-left: 150px;
  margin-top: 35px;
  width: 65%;
}
.pane-row {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  .row-submi {
    position: relative;
    margin-left: 40px;
  }
}
.btn-size {
  width: 9vh;
}
.pane-NewIph {
  position: relative;
  margin-left: 70px;
  margin-top: 30px;
  width: 70%;
}
.input-with-select {
  position: relative;
  margin-left: 70px;
  width: 70%;
}
.el-form-item__content {
  margin-left: 191px;
}
</style>

<style>
.personal-main
  .el-radio-button__orig-radio:disabled:checked
  + .el-radio-button__inner {
  background-color: #409eff;
}
</style>
